"use client";

import { css } from 'styled-components';
import { whenDisabled, whenFocused, whenHovered, whenPressed } from 'utils';
import { theme } from '@frameio/vapor-theme';
import { IconAfter, IconBefore } from './Icons';
import type { ButtonColor } from './types';

type VariantProps = {
  disabled: boolean;
  $color: ButtonColor;
};

const { primary: buttonPrimary } = theme.colors.components.button;

export function linkVariant() {
  return css<VariantProps>`
    background: none;
    padding: 0;

    ${baseStyles};

    ${IconBefore} {
      margin-left: 0;
    }

    ${IconAfter} {
      margin-right: 0;
    }

    ${whenHovered} {
      ${hoverStyles};
    }

    ${whenFocused} {
      box-shadow: none !important;
      text-decoration: underline;
      ${focusStyles};
    }

    &[aria-expanded='true'],
    ${whenPressed} {
      ${activeStyles};
    }

    ${whenDisabled} {
      color: ${theme.colors.text.interactive.disabled};
      pointer-events: none;
    }
  `;
}

function baseStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      color: ${buttonPrimary.background};
    `;
  }

  if (p.$color === 'error') {
    return css`
      color: ${theme.colors.text.interactive.error};
    `;
  }

  return css`
    color: ${theme.colors.components.link.text};
  `;
}

function hoverStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      color: ${buttonPrimary.interactive.background.hover};
    `;
  }

  if (p.$color === 'error') {
    return css`
      color: ${theme.colors.text.interactive.error};
    `;
  }

  return css`
    color: ${theme.colors.components.link.interactive.text.hover};
  `;
}

function focusStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      color: ${buttonPrimary.background};
    `;
  }

  if (p.$color === 'error') {
    return css`
      color: ${theme.colors.text.interactive.error};
    `;
  }

  return css`
    color: ${theme.colors.components.link.interactive.text.focus};
  `;
}

function activeStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      color: ${theme.colors.brand.dark};
    `;
  }

  if (p.$color === 'error') {
    return css`
      color: ${theme.colors.text.interactive.error};
    `;
  }

  return css`
    color: ${theme.colors.components.link.interactive.text.active};
  `;
}
